'use strict';

var MarketProductGroupProfileChartFilterFactory = function MarketProductGroupProfileChartFilterFactory(DemandFilter, angularHelper) {
  var filtersNamesList = ['MarketProductGroupDateRangeFilterFactory', 'MarketProductGroupMarketFilterFactory', 'MarketProductGroupSeasonFilterFactory', 'MarketProductGroupDowFilterFactory', 'MarketProductGroupClassGroupFilterFactory', 'MarketPOSFilterFactory'];
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function MarketProductGroupProfileChartFilter() {
    DemandFilter.call(this, 'market-product-group', 'profile-chart');
    this.registerFilters(injectedFilters);
  }
  MarketProductGroupProfileChartFilter.constructor = MarketProductGroupProfileChartFilter;
  MarketProductGroupProfileChartFilter.prototype = Object.create(DemandFilter.prototype);
  return MarketProductGroupProfileChartFilter;
};
MarketProductGroupProfileChartFilterFactory.$inject = ['DemandFilterFactory', 'AngularHelper'];
module.exports = MarketProductGroupProfileChartFilterFactory;